import { makeStyles } from '@material-ui/core/styles'

export const snackbarStyle = makeStyles(() => ({
  root: {
    top: 84
  }
}))

export default snackbarStyle
